<div class="tax-strategy upload-client d-flex flex-column new-input-fields" [style.height]="isRapMaximized ? '100%' : 'calc(100vh - 125px)'">
  <div class="d-flex justify-content-between save-draft-sec" [ngClass]="{'rap-maximized-header': isRapMaximized}">
    <div class="pointer" *ngIf="documentId && ((ocrStatus === 'Error' && user === 'support@taxplaniq.com') || (ocrStatus !== 'Error'))" (click)="view1040Document()"><img src="../../../../images/core-focus/external-link.png"/><u class="save-draft">View 1040 PDF</u></div>
    <div class="pointer" *ngIf="(!currentEnvironment.production && (org === 'stag-taxplaniq' || org === 'test-taxplaniq'))
         || (currentEnvironment.production && user === 'support@taxplaniq.com')" (click)="triggerShowViewJsonPopup()"><img src="../../../../images/core-focus/external-link.png"/><u class="save-draft">view JSON</u></div>
    <!-- Hide "Save as Draft" in Open-in-RAP edit mode (isReviewPlan=true) -->
    <div *ngIf="!draftSaved && !isReviewPlan"
         [class.pointer]="!isNewPlanCreationBlocked"
         [attr.aria-disabled]="isNewPlanCreationBlocked"
         [attr.title]="planCreationBlockMessage"
         (click)="!isNewPlanCreationBlocked && saveCurrentDataAsDraft()"><img src="../../../../images/tpiq-icons/save-draft.png"/><u class="save-draft">Save as Draft</u></div>
    <div *ngIf="draftSaved && !isReviewPlan"><img src="../../../../images/tpiq-icons/check-circle.png"/><span class="save-draft">Saved</span></div>
    <div class="pointer" *ngIf="(org === 'stag-taxplaniq' || org === 'test-taxplaniq' || (currentEnvironment.production && user === 'support@taxplaniq.com')) && newQuestionarieData && isQuestionnarieInRapEnabled" (click)="viewQuestionarieDetails()"><img src="../../../../images/core-focus/external-link.png"/><u class="save-draft">View Questionarie</u></div>
  </div>
  <div class="d-flex justify-content-between mb-5">
    <div class="" style="width: 10%"></div>
    <div class="d-flex justify-content-between create-strategy-sec-bar" style="width: 80%">
      <div class="pointer create-strategy-sec" *ngIf="!secReview.clientInfo" [ngClass]="{'is-active': currentSection == 'clientInfo'}" (click)="moveToSection('clientInfo')">
        <div class="sec-name">Client</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.clientInfo" (click)="moveToSection('clientInfo')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Client</div>
      </div>
      <div class="section-bar" [ngClass]="{'is-active-bar': currentSection == 'clientInfo', 'section-bar-success': secReview.clientInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.planInfo" [ngClass]="{'is-active': currentSection == 'planInfo'}" (click)="moveToSection('planInfo')">
        <div class="sec-name">Tax Summary</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.planInfo" (click)="moveToSection('planInfo')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Tax Summary</div>
      </div>

      <div class="section-bar" *ngIf="isQuestionnarieInRapEnabled" [ngClass]="{'is-active-bar': currentSection == 'planInfo', 'section-bar-success': secReview.planInfo}"></div>
        <div class="pointer create-strategy-sec" *ngIf="!secReview.questionnaire && isQuestionnarieInRapEnabled" [ngClass]="{'is-active': currentSection == 'questionnaire'}" (click)="moveToSection('questionnaire')">
          <div class="sec-name">Discovery</div>
        </div>
        <div class="pointer reviewed-success" *ngIf="secReview.questionnaire && isQuestionnarieInRapEnabled" (click)="moveToSection('questionnaire')">
          <i class="icon ion-ios-checkmark-empty"></i>
          <div class="sec-name">Discovery</div>
        </div>

       <div class="section-bar" *ngIf="isQuestionnarieInRapEnabled" [ngClass]="{'is-active-bar': currentSection == 'questionnaire', 'section-bar-success': secReview.questionnaire}"></div>
        <div class="pointer create-strategy-sec" *ngIf="!secReview.strategiesInfo && isQuestionnarieInRapEnabled" [ngClass]="{'is-active': currentSection == 'strategiesInfo'}" (click)="moveToSection('strategiesInfo')">
          <div class="sec-name">Selection</div>
        </div>

      <div class="section-bar" *ngIf="!isQuestionnarieInRapEnabled" [ngClass]="{'is-active-bar': currentSection == 'planInfo', 'section-bar-success': secReview.planInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.strategiesInfo && !isQuestionnarieInRapEnabled" [ngClass]="{'is-active': currentSection == 'strategiesInfo'}" (click)="moveToSection('strategiesInfo')">
        <div class="sec-name">Selection</div>
      </div>
      
      <div class="pointer reviewed-success" *ngIf="secReview.strategiesInfo" (click)="moveToSection('strategiesInfo')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Selection</div>
      </div>
      <div class="section-bar" [ngClass]="{'is-active-bar': currentSection == 'strategiesInfo', 'section-bar-success': secReview.strategiesInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.reviewInfo" [ngClass]="{'is-active': currentSection == 'review'}" (click)="moveToSection('review')">
        <div class="sec-name">Review</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.reviewInfo" (click)="moveToSection('review')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Review</div>
      </div>
      <div class="section-bar" [ngClass]="{'is-active-bar': currentSection == 'review', 'section-bar-success': secReview.reviewInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.roiFeeInfo" [ngClass]="{'is-active': currentSection == 'roiFee'}" (click)="moveToSection('roiFee')">
        <div class="sec-name">ROI Fee</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.roiFeeInfo" (click)="moveToSection('roiFee')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">ROI Fee</div>
      </div>
      <div class="section-bar" [ngClass]="{'is-active-bar': currentSection == 'roiFee', 'section-bar-success': secReview.roiFeeInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.tasksList" [ngClass]="{'is-active': currentSection == 'tasksInfo'}" (click)="moveToSection('tasksInfo')">
        <div class="sec-name">Tasks</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.tasksList" (click)="moveToSection('tasksInfo')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Tasks</div>
      </div>
    </div>
    <div class="" style="width: 10%"></div>
  </div>

  <div #scrollContainer class="d-flex flex-fill min-h-0 overflow-auto">
    <div class="medium-12 columns" *ngIf="currentSection == 'clientInfo'">
      <div class="row">
        <div class="medium-12 columns mb-2">
          <label style="font-weight: 600;color: #333333;">Review Client Details</label>
        </div>
      </div>
      <div class="row tax-planning-client">
        <div class="medium-6 columns">
          <label>
            First Name*
            <input type="text" [(ngModel)]="effectiveClient.firstName" placeholder="First Name"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Last Name*
            <input type="text" [(ngModel)]="effectiveClient.lastName" placeholder="Last Name"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Email
            <input type="text" [(ngModel)]="effectiveClient.email" placeholder="Email"/>
            <div class="error" *ngIf="effectiveClient.email && !effectiveClient.email.match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')">Please check email format</div>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Phone Number
            <input type="text" input-mask [(ngModel)]="effectiveClient.phoneNumber" placeholder="Phone number"/>
            <!--            <div class="error" *ngIf="effectiveClient.phoneNumber && !effectiveClient.phoneNumber.match('^[0-9]{10}$')">Phone number should have 10 digits only</div>-->
          </label>
        </div>

        <!-- commented out Filling Status field as per UX feedback 5 dec by Ishan -->
        <!-- <div class="medium-6 columns">
          <label class="input-border">
            Filing Status
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="filingStatusList" [setPlaceHolder]="'Filing Status'" [setSearchKey]="'name'" [setValueKey]="'name'" [setDefaultValue]="defaultStatus"
                                   (onValueSelect)="onFilingSelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div> -->
        <div class="medium-6 columns mt-0">
          <label class="d-flex gap-2 align-items-center">Enable Client Portal <input style="margin: 0;" type="checkbox" [(ngModel)]="effectiveClient.enableClientPortal" [disabled]="currentPlan && currentPlan.toLowerCase().includes('basic')"/></label>
         
          <div>
            <span style="font-size: 12px; color: #f1645a" *ngIf="currentPlan && currentPlan.toLowerCase().includes('basic')">{{portalMessage}}</span>
          </div>
        </div>
        <div class="medium-12 columns mt-4">
          <div class="py-2" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px; border: 1px solid rgba(234, 236, 240, 0.5)">          
            <div class="row pt-1" *ngFor="let relatedParty of (effectiveClient.relatedParties || []); let index = index;">
              <div class="medium-5 columns">
                <label>Related Party*
                  <input type="text" [(ngModel)]="relatedParty.name" placeholder="Related Party"/>
                </label>
              </div>
              <div class="medium-5 columns">
                <label>Type
                  <app-tpiq-select-dropdown [setData]="types" [includeNone]="false" (onValueSelect)="setType($event, relatedParty)"
                                        [setDefaultValue]="relatedParty.type" [setSearchKey]="'name'" [setPlaceHolder]="'Type'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </label>
              </div>
              <div class="medium-2 columns">
                <i style="position: relative;top: 25px;" class="material-icons delete-icon" (click)="removeRelatedParty(index)">delete</i>
              </div>
            </div>

            <div style="padding: 5px 15px">
              <span class="pointer badge-tooltip" (click)="addRelatedParty()">
                <i class="material-icons float-left add-icon">add_circle_outline</i>
                <span class="float-left add-text">Related Party</span>
                <span class="topTooltiptext related-parties-tooltip">
                  Related parties can be any existing or potential businesses or related individuals to your client
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" *ngIf="currentSection == 'planInfo'">
      <div class="d-flex flex-column">
        <div>
          <label style="font-weight: 600;color: #333333;">Review Tax Summary</label>
        </div>
      </div>

      <div class="tax-strategy">
        <div foundation class="reports">
          <div class="row">
            <div class="medium-12 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">Plan Name*</div>
                <div style="flex:1">
                  <label>
                    <input type="text" [(ngModel)]="newTaxPlan.name" placeholder="Plan Name"/>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">Total Tax*</div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <input type="text" placeholder="Total Tax" [(ngModel)]="newTaxPlan.totalTax" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (focus)="captureTaxSummaryBaseline()" (blur)="calculateEffectiveRate()"/>
                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>
                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Total Tax', newTaxPlan.totalTax, 'amount')">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">Taxable Income*</div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <input type="text" placeholder="Taxable Income" [(ngModel)]="newTaxPlan.taxableIncome" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (focus)="captureTaxSummaryBaseline()" (blur)="calculateEffectiveRate('Taxable Income')"/>
                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>
                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Taxable Income', newTaxPlan.taxableIncome, 'amount')">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">
                  Effective Rate(%)*
                </div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <!-- Canonical rule (868k4yvkt): a taxable income of zero or less has
                         no effective rate to report, so show the business-loss state
                         rather than a stale or zeroed percentage. Matches the Tax
                         Summary card on Plan details. -->
                    <span *ngIf="!showEffectiveRate()" class="margin-bottom-0">n/m (business loss)</span>
                    <input *ngIf="showEffectiveRate()" class="margin-bottom-0" type="text" placeholder="Effective Rate" [(ngModel)]="newTaxPlan.effectiveRate"/>
                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Effective Rate', newTaxPlan.effectiveRate)">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>

                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>
                  </label>
                  <span style="font-size: 12px; color: #1570EF;">Calculated based using (Total tax / Total taxable income)</span>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">
                  Filing Status
                </div>
                <label>
                  <app-tpiq-select-dropdown [includeNone]="false" [setData]="filingStatusList" [setPlaceHolder]="'Filing Status'" [setSearchKey]="'name'" [setValueKey]="'name'" [setDefaultValue]="defaultStatus"
                                   (onValueSelect)="onFilingSelect($event)"></app-tpiq-select-dropdown>
                </label>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">
                  <span class="text-center">Marginal Rate(%)*</span>
                  <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
                    <span class="bottomTooltiptext" style="width: 175px;">
                      Click here to link to current marginal tax rates
                    </span>
                  </span>
                </div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <input type="text" placeholder="Marginal Rate" [(ngModel)]="newTaxPlan.marginalRate" (blur)="calculateCapGainsRate()"/>
                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Marginal Rate', newTaxPlan.marginalRate)">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>

                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">
                  <span class="text-center">Cap Gains Rate(%)*</span>
                  <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
                    <span class="bottomTooltiptext" style="width: 175px;">
                      Click here to link to current cap gains tax rates
                    </span>
                  </span>
                </div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <input type="text" placeholder="Cap Gains Rate" [(ngModel)]="newTaxPlan.capGainRate"/>
                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>

                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('Cap Gains Rate', newTaxPlan.capGainRate)">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">C Corp Flat Rate(%)*</div>
                <div style="flex:1">
                  <label class="d-flex review-field input-action-badge">
                    <input type="text" placeholder="C Corp Flat Rate" [(ngModel)]="newTaxPlan.ccropFlatRate"/>
                    <span class="text-center badge-tooltip field-position">
                      <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                      <span class="bottomTooltiptext" style="width: 120px;">
                        Review The field
                      </span>
                    </span>

                    <span class="action-badge">
                      <span class="bold pointer" (click)="createTaskForReviewField('C Corp Flat Rate', newTaxPlan.ccropFlatRate)">
                        <img class="info-icon" src="../../../../images/core-focus/flag.png"/>Create a Task
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">Tax Plan Year*</div>
                <div style="flex:1">
                  <label>
                    <app-tpiq-select-dropdown [setData]="years" [includeNone]="false" (onValueSelect)="setYear($event)"
                                           [setDefaultValue]="newTaxPlan.taxYear || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Tax Plan Year'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-12 column">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">
                  <span class="text-center">Home State*</span>
                </div>
                <div style="flex:1">
                  <label>
                    <app-tpiq-select-dropdown [setData]="states" [setPlaceHolder]="'Select State'" [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'short'" [setDefaultValue]="newTaxPlan.homeState"
                                           (onValueSelect)="onHomeStateSelect($event)" [setOnBlur] = "true"></app-tpiq-select-dropdown>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2">
                  <span class="text-center" class="popup-label">Individual State Rate(%)</span>
                  <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('individual')"></i>
              <span class="bottomTooltiptext" style="width: 175px;">Click here to link to current individual state rates</span>
            </span>
                </div>
                <div style="flex:1">
                  <label>
                    <div style="position:relative;">
                      <input #individualStateRateInput type="text" placeholder="10" [(ngModel)]="newTaxPlan.individualStateRate" (blur)="onStateRateBlur('individualStateRate')"/>
                      <span *ngIf="newTaxPlan.individualStateRate !== null && newTaxPlan.individualStateRate !== undefined && newTaxPlan.individualStateRate !== ''"
                            style="position:absolute; top:50%; transform:translateY(-50%); pointer-events:none; color:#8a8a8a;"
                            [style.left.px]="getStateRatePercentOffset(individualStateRateInput, newTaxPlan.individualStateRate)">%</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-6 column">
              <div class="address-bar row-margin">
                <div style="flex:2">
                  <span class="text-center" class="popup-label">Corporate State Rate(%)</span>
                  <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('corporate')"></i>
              <span class="bottomTooltiptext" style="width: 175px;">Click here to link to current corporate state rates</span>
            </span>
                </div>
                <div style="flex:1">
                  <label>
                    <div style="position:relative;">
                      <input #corporateStateRateInput type="text" placeholder="10" [(ngModel)]="newTaxPlan.corporateStateRate" (blur)="onStateRateBlur('corporateStateRate')"/>
                      <span *ngIf="newTaxPlan.corporateStateRate !== null && newTaxPlan.corporateStateRate !== undefined && newTaxPlan.corporateStateRate !== ''"
                            style="position:absolute; top:50%; transform:translateY(-50%); pointer-events:none; color:#8a8a8a;"
                            [style.left.px]="getStateRatePercentOffset(corporateStateRateInput, newTaxPlan.corporateStateRate)">%</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-12 column mb-4">
              <div class="address-bar row-margin">
                <div style="flex:2" class="popup-label">Description</div>
                <div style="flex:1">
                  <label>
                    <div style="border:1px solid #cacaca;padding:10px;" [froalaEditor]="editorOptions" [(froalaModel)]="newTaxPlan.description"></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="medium-12 column" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
              <div class="address-bar row-margin">
                <span class="pointer popup-label" style="color: #1570EF" (click)="addCustomTaxRate()"><i class="icon ion-ios-plus-outline"></i>Custom Rate</span>
              </div>
              <div class="row address-bar row-margin" *ngFor="let customTaxRate of newTaxPlan.customTaxRates;let idx = index" [hidden]="!shouldShowCustomRate(customTaxRate)">
                <div class="medium-6 columns">
                  <div style="flex:2">
                    <input type="text" class="custom-tax-rate-name" placeholder="Tax Rate Name" [(ngModel)]="customTaxRate.name"/>
                  </div>
                </div>
                <div class="medium-6 columns">
                  <div style="flex:1">
                    <input type="text" class="custom-tax-rate" placeholder="25" [(ngModel)]="customTaxRate.rate"/>
                    <span class="pointer custom-rate-remove" (click)="removeCustomTaxRate(idx)"><i class="icon ion-ios-trash-outline"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'questionnaire' && isQuestionnarieInRapEnabled">
    <app-rap-questionnaire [ocrData]="ocrData" [chatId] ="chatId" [questionnaireTrack] = "questionnaireTrack" [documentId] = "documentId" [plan]="newTaxPlan" [aiSuggestedStrategies]="ocrSuggetions" [messages]="chatMessages" [questionnaireUtilization]="questionnaireUtilization" [isRapEditMode]="isRapEditMode" [sessionId]="rapSession?.meta?.sessionId" (messagesChange)="chatMessages = $event" (chatIdChange)="onChatIdChange($event)" (nextClicked)="goToNextSection($event)" (sectionChange)="handleQuestionnarieSectionChange($event)"></app-rap-questionnaire>
    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'strategiesInfo'">
      <app-tax-strategies-info [plan]="newTaxPlan" [states]="states" [ocrStatus]="ocrStatus" [strategies]="allTaxStrategies" [selectedStrategies]="selectedStrategies" [aiSuggestedStrategies]="ocrSuggetions" [forceAITab]="isRapEditMode" (onItemAddedToSelectedList)="setSelectedItems($event)"></app-tax-strategies-info>
    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'review' && newTaxPlan && newTaxPlan.id">
      <app-review-tax-strategies [client]="client" [plan]="newTaxPlan" [states]="states" [allTaxStrategies]="allTaxStrategies" [strategies]="strategiesForReview" [reviewedStrategiesData]="reviewedStrategies" (onStrategyRiviewedSuccess)="setReviewedStrategiesList($event)"
                                  (onCreateTaskAction)="addTaskToTheList($event)" (onStrategyRemoved)="setSelectedItems($event, 'strategyRemove')" [isRapMaximized]="isRapMaximized" [isRapEditMode]="isRapEditMode"></app-review-tax-strategies>
    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'roiFee' && newTaxPlan && newTaxPlan.id">
      <app-roi-fee-numbers #roiFeeInfo [client]="client" [plan]="newTaxPlan" [year1Savings]="year1Savings" [year2Savings]="year2Savings" [planCostLines]="planCostLines"></app-roi-fee-numbers>
    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'tasksInfo' && newTaxPlan && newTaxPlan.id">
      <app-plan-strategy-tasks [client]="client" [plan]="newTaxPlan" [tasks]="tasksList"></app-plan-strategy-tasks>
    </div>
  </div>
  <div class="flex-shrink-0">
    <div class="medium-12" *ngIf="currentSection == 'clientInfo'">
      <button class="button small float-right mt-4" [disabled]="!isClientInfoValid()" (click)="goToNextSection('planInfo')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="closeCreatePopup()">Cancel</button>
    </div>
    
     <div class="medium-12" *ngIf="currentSection == 'planInfo' && !isQuestionnarieInRapEnabled">
      <p *ngIf="isNewPlanCreationBlocked" class="text-danger">{{planCreationBlockMessage}}</p>
      <button class="button small float-right mt-4" [disabled]="!isPlanInfoNextEnabled() || isNewPlanCreationBlocked"
              [title]="planCreationBlockMessage" (click)="goToNextSection('strategiesInfo')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="goToPreviousSection('clientInfo')">Back</button>
    </div>
    <div class="medium-12" *ngIf="currentSection == 'strategiesInfo' && !isQuestionnarieInRapEnabled">
      <button class="button small float-right mt-4" [disabled]="selectedStrategies && selectedStrategies.length === 0" (click)="goToNextSection('review')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="goToPreviousSection('planInfo')">Back</button>
    </div>

    <div class="medium-12" *ngIf="currentSection == 'planInfo' && isQuestionnarieInRapEnabled" >
      <p *ngIf="isNewPlanCreationBlocked" class="text-danger">{{planCreationBlockMessage}}</p>
      <button class="button small float-right mt-4" [disabled]="!isPlanInfoNextEnabled() || isNewPlanCreationBlocked"
              [title]="planCreationBlockMessage" (click)="goToNextSection('questionnaire')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="goToPreviousSection('clientInfo')">Back</button>
    </div>
    <div class="medium-12" *ngIf="currentSection == 'questionnaire' && isQuestionnarieInRapEnabled">
      <button [attr.data-testid]="questionnaireTrack == 1 ? 'discovery-chat-next' : 'discovery-intro-next'" class="button small float-right" (click)="goToNextSection('strategiesInfo')">Next</button>
      <button [attr.data-testid]="questionnaireTrack == 1 ? 'discovery-chat-back' : 'discovery-intro-back'" class="button small float-right cancel-button" (click)="goToPreviousSection('planInfo')">Back</button>
    </div>

    <div class="medium-12" *ngIf="currentSection == 'strategiesInfo' && isQuestionnarieInRapEnabled">
      <button class="button small float-right mt-4" [disabled]="selectedStrategies && selectedStrategies.length === 0" (click)="goToNextSection('review')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="goToPreviousSection('questionnaire')">Back</button>
    </div>
    <div class="medium-12 mt-4 d-flex justify-content-end align-items-center" *ngIf="currentSection == 'review'">
      <button
        class="button small cancel-button"
        (click)="goToPreviousSection('strategiesInfo')"
      >
        Back
      </button>
      <div class="tp-tooltip-wrapper">
        <button
          class="button small"
          [disabled]="(reviewedStrategies && reviewedStrategies.length === 0) || ((selectedStrategies.length - reviewedStrategies.length) !== 0)"
          (click)="goToNextSection('roiFee')"
        >
          Next
        </button>
        <div class="tp-tooltip text-center" [innerHTML]="reviewBtnTooltipContent"></div>
      </div>
    </div>
    <div class="medium-12" *ngIf="currentSection == 'roiFee'">
      <button class="button small float-right mt-4" (click)="goToNextSection('tasksInfo')">Next</button>
      <button class="button small float-right mt-4 cancel-button" (click)="goToPreviousSection('review')">Back</button>
    </div>
    <div class="medium-12" *ngIf="currentSection == 'tasksInfo'">
      <!-- RAP Edit Mode: Back and Cancel on the left; Overwrite and Create as New on the right -->
      <ng-container *ngIf="isRapEditMode">
        <button class="button small float-right" style="background-color: #1570EF;" [disabled]="isFinalSaveInProgress" (click)="openCreateNewDialog()">Create as New Plan</button>
        <button class="button small float-right" style="background-color: #1570EF; margin-right: 10px;" [disabled]="isFinalSaveInProgress" (click)="commitRapSession('OVERWRITE')">Overwrite Existing Plan</button>
        <button class="button small float-right cancel-button" style="margin-right: 10px;" (click)="cancelRapSession()">Cancel</button>
        <button class="button small float-right cancel-button" style="margin-right: 10px;" (click)="goToPreviousSection('roiFee')">Back</button>
      </ng-container>
      
      <!-- Normal Mode: Show standard create button -->
      <ng-container *ngIf="!isRapEditMode">
        <button class="button small float-right" (click)="validateTasksAndUpdatePlan()">{{(tasksList && tasksList.length === 0) ? 'Create Plan' : 'Create'}}</button>
        <button class="button small float-right cancel-button" (click)="goToPreviousSection('review')">Back</button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Create as New Plan dialog -->
<div *ngIf="showCreateNewDialog" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;">
  <div style="background:#fff;border-radius:8px;padding:28px 32px;width:480px;max-width:90vw;box-shadow:0 8px 32px rgba(0,0,0,0.18);">
    <h5 style="margin-bottom:20px;font-weight:600;color:#444;">Create as New Plan</h5>
    <div style="margin-bottom:16px;">
      <div class="popup-label" style="margin-bottom:6px;">Source Plan Name</div>
      <div style="padding:8px 12px;background:#f5f5f5;border-radius:4px;color:#696E73;border:1px solid #DCDEDD;">{{rapSourcePlanName}}</div>
    </div>
    <div style="margin-bottom:24px;">
      <div class="popup-label" style="margin-bottom:6px;">New Plan Name*</div>
      <input type="text" [(ngModel)]="createNewPlanName" placeholder="Enter new plan name" style="width:100%;padding:8px 12px;border:1px solid #CACACA;border-radius:4px;font-size:14px;"/>
    </div>
    <div style="display:flex;justify-content:flex-end;gap:12px;">
      <button class="button small cancel-button" (click)="showCreateNewDialog=false">Cancel</button>
      <button class="button small" style="background-color:#1570EF;" [disabled]="isFinalSaveInProgress" (click)="confirmCreateNew()">Create Plan</button>
    </div>
  </div>
</div>
